import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { RubricFilterDropdownComponent } from './rubric-filter-dropdown.component';

// TODO - remove when rubricFeedbackViewer STAB-748
export const ngxRubricFilterDropdown = angular.module('ngxRubricFilterDropdownModule', [])
	.directive('ngxRubricFilterDropdown', downgradeComponent({ component: RubricFilterDropdownComponent }))
	.name;
